
let classHost = process.env.classHost;
let nodeDomain = process.env.nodeDomain;
let domain = process.env.domain;
let aioIP = process.env.aioIP;
let envType = process.env.envType;
let isDev = process.env.isDev; // 开发版本
let rsaPublicKey = process.env.rsaPublicKey;
let h5EventHost = process.env.h5EventHost;

let isComplexVersion = true; //是否是功能复杂的版本
import Vue from "vue";

export default {
  isDev,
  domain,
  aioIP,
  envType,
  classHost,
  nodeDomain,
  rsaPublicKey,
  h5EventHost,
  isComplexVersion,
  getUrlParam(name, url) {
    let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)"); //构造一个含有目标参数的正则表达式对象
    // 优化可对传入的url拆分（用于微信和音频后台返回url的解析）
    if (url) {
      url = "?" + url;
    } else {
      url = window.location.href;
    }

    let index = url.indexOf("?");
    let query = url.substr(index);

    let r = query.substr(1).match(reg); //匹配目标参数
    if (r != null) return decodeURI(r[2]);
    return null; //返回参数值
  },
  //比较两个数组，并返回不同的合集
  difference(arr1, arr2) {
    let diff = [];
    let tmp = arr2;

    arr1.forEach((val1, i) => {
      if (arr2.indexOf(val1) < 0) {
        diff.push(val1);
      } else {
        tmp.splice(tmp.indexOf(val1), 1);
      }
    });

    return diff.concat(tmp);
  },
  //数组或对象的深copy
  deepCopy(o) {
    if (o instanceof Array) {
      let n = [];
      for (let i = 0; i < o.length; ++i) {
        n[i] = this.deepCopy(o[i]);
      }
      return n;
    } else if (o instanceof Object) {
      let n = {};
      for (let i in o) {
        n[i] = this.deepCopy(o[i]);
      }
      return n;
    } else {
      return o;
    }
  },

  successMsg(msg, title = "成功") {
    Vue.prototype.$notify({
      type: "success",
      title: title,
      message: msg,
      offset: 80,
    });
  },
  errorMsg(msg, title = "提示", type = "error") {
    Vue.prototype.$notify({
      type: type,
      title: title,
      message: msg,
      offset: 80,
    });
  },
  //页面跳转；
  refreshTo(url, params) {
    if (params) {
      for (let k in params) {
        url += `&${k}=${params[k]}`;
      }
      url = url.replace("&", "?");
    }
    location.href = url;
  },
  /**
   * 存储localStorage
   */
  setStore(name, content) {
    if (!name) return;
    if (typeof content !== "string") {
      content = JSON.stringify(content);
    }
    window.localStorage.setItem(name, content);
  },

  /**
   * 获取localStorage
   */
  getStore(name) {
    if (!name) return;
    return window.localStorage.getItem(name);
  },

  /**
   * 删除localStorage
   */
  removeStore(name) {
    if (!name) return;
    window.localStorage.removeItem(name);
  },
  //判断朗格对象是否相等
  isObjectValueEqual(a, b) {
    let aProps = Object.getOwnPropertyNames(a);
    let bProps = Object.getOwnPropertyNames(b);

    if (aProps.length != bProps.length) {
      return false;
    }

    for (var i = 0; i < aProps.length; i++) {
      var propName = aProps[i];
      if (a[propName] !== b[propName]) {
        return false;
      }
    }
    return true;
  },
  createUuid() {
    var s = [];
    var hexDigits = "0123456789abcdef";
    for (var i = 0; i < 36; i++) {
      s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
    }
    s[14] = "4"; // bits 12-15 of the time_hi_and_version field to 0010
    s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
    s[8] = s[13] = s[18] = s[23] = "-";

    var uuid = s.join("");
    return uuid;
  },
  /**
   * 日期格式化
   */
  dateFormat(date, format) {
    format = format || "yyyy-MM-dd hh:mm:ss";

    if (date !== "Invalid Date") {
      let o = {
        "M+": date.getMonth() + 1, //month
        "d+": date.getDate(), //day
        "h+": date.getHours(), //hour
        "m+": date.getMinutes(), //minute
        "s+": date.getSeconds(), //second
        "q+": Math.floor((date.getMonth() + 3) / 3), //quarter
        S: date.getMilliseconds(), //millisecond
      };
      if (/(y+)/.test(format))
        format = format.replace(
          RegExp.$1,
          (date.getFullYear() + "").substr(4 - RegExp.$1.length)
        );
      for (let k in o)
        if (new RegExp("(" + k + ")").test(format))
          format = format.replace(
            RegExp.$1,
            RegExp.$1.length === 1
              ? o[k]
              : ("00" + o[k]).substr(("" + o[k]).length)
          );
      return format;
    }
    return "";
  },
};

Date.prototype.format = function (format) {
  let date = {
    "M+": this.getMonth() + 1,
    "d+": this.getDate(),
    "h+": this.getHours(),
    "m+": this.getMinutes(),
    "s+": this.getSeconds(),
    "q+": Math.floor((this.getMonth() + 3) / 3),
    "S+": this.getMilliseconds(),
  };
  if (/(y+)/i.test(format)) {
    format = format.replace(
      RegExp.$1,
      (this.getFullYear() + "").substr(4 - RegExp.$1.length)
    );
  }
  for (let k in date) {
    if (new RegExp("(" + k + ")").test(format)) {
      format = format.replace(
        RegExp.$1,
        RegExp.$1.length == 1
          ? date[k]
          : ("00" + date[k]).substr(("" + date[k]).length)
      );
    }
  }
  return format;
};



// WEBPACK FOOTER //
// ./src/common/public.js